<div class="form-group mb-20" [class.has-error]="name.invalid && name.touched">
    <label>{{ "widget_product_name_product" | translate }}</label>
    <input
        type="text"
        class="form-control"
        placeholder="{{ 'widget_product_name_placeholder' | translate }}"
        [formControl]="name"
    />
    @if (name.invalid && name.touched) {
        <span class="help-block small">
            {{ "control_errors_required" | translate }}
        </span>
    }
</div>
<div class="form-group mb-20">
    <label>{{ "widget_product_short_description_product" | translate }}</label>
    <web-editor
        class="sp-editor form-control control-textarea short-description"
        [toolbarMenu]="'link lists code'"
        [placeholder]="'widget_product_short_description_placeholder' | translate"
        [content]="shortDescription.value"
        (changeContent)="shortDescription.setValue($event)"
    ></web-editor>
</div>
<div class="form-group mb-20" [class.has-error]="description.invalid && description.touched">
    <label>{{ "widget_product_description_product" | translate }}</label>
    <web-editor
        class="sp-editor form-control control-textarea"
        [toolbarMenu]="'link lists code'"
        [placeholder]="'widget_product_description_placeholder' | translate"
        [content]="description.value"
        (changeContent)="description.setValue($event)"
    ></web-editor>
    @if (description.invalid && description.touched) {
        <span class="help-block small">
            {{ "control_errors_max_length" | translate: { MAX_LENGTH: DESCRIPTION_MAX_LENGTH } }}
        </span>
    }
</div>
